import React, { FC, useState, useEffect, KeyboardEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notification } from 'antd'
import { SmileOutlined } from '@ant-design/icons'
import type { IAppState } from '@/store/reducers'
import { useHistory } from 'react-router-dom'
import { replace } from 'connected-react-router'
import type { ISigninPayload } from '@/store/models/auth.model'
import { signin, signupSuccess } from '@/store/actions/auth.action'
import { requestFail } from '@/store/actions/common.action'
import { useTranslation } from 'react-i18next'
import { setSessionRequestMsg, getSessionRequestMsg } from '@/router'

export const notifyMsg = (msg: string): void => {
    if (msg) {
        // const sessionRequest = sessionStorage.getItem('requestMsg')
        const sessionRequest = getSessionRequestMsg()
        console.log('sessionStorage requestMsg login: ', sessionRequest)
        if (sessionRequest) {
            setTimeout(() => {
                // sessionStorage.removeItem('requestMsg')
                setSessionRequestMsg('')
            }, 1000)
            return
        }
        // sessionStorage.setItem('requestMsg', msg)
        setSessionRequestMsg(msg)
        setTimeout(() => {
            // sessionStorage.removeItem('requestMsg')
            setSessionRequestMsg('')
        }, 1000)
        const args = {
            message: msg,
            description: '',
            icon: <SmileOutlined style={{ color: '#e1931e' }} />,
            duration: 3,
        }
        notification.open(args)
    }
}

const Login: FC = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const signinState = useSelector((state: IAppState) => state.auth.signin)
    const signoutState = useSelector((state: IAppState) => state.auth.signup)
    const { url, param, state } = useSelector((state: IAppState) => state.common)
    
    const [formData, setFormData] = useState<ISigninPayload>({
        clientId: '',
        username: '',
        password: '',
        type: 0,
        message: t('login') + (i18n.language !== 'zh' ? ' ' : '') + t('success')
    })

    const onLogin = () => {
        if (formData.username === '' || formData.password === '') {
            notifyMsg(t('userPswMsg'))
            return
        }
        dispatch(signin(formData))
    }

    useEffect(() => {
        dispatch(requestFail(''))
        if (signinState.loaded) {
            // 登录错误
            if (!signinState.success) {
                // const sessionRequest = sessionStorage.getItem('requestMsg')
                const sessionRequest = getSessionRequestMsg()
                if (sessionRequest) {
                    setTimeout(() => {
                        // sessionStorage.removeItem('requestMsg')
                        setSessionRequestMsg('')
                    }, 1000)
                    return
                }
                if (signinState.message) {
                    notifyMsg(signinState.message.split('--').shift() || '')
                }
            } else {
                const searchObj = new URLSearchParams(location.search)
                const redirect = searchObj.get('redirect')
                if (redirect === 'assistant') {
                    history.replace(`/${location.search}`, state)
                } else {
                    // 设置 connected-react-router
                    dispatch(replace(`${url}${param}`, state))
                    // 跳转回之前页面
                    history.replace(`${url}${param}`, state)
                }
            }
        }
        // 登出成功
        if (signoutState.loaded && signoutState.success && signoutState.message) {
            notifyMsg(signoutState.message)
            dispatch(signupSuccess(''))
        }
    }, [signinState, signoutState])

    return (
        <div className='login_page'>
            <div className='title'>ITMT TECH Master</div>
            <div className="panel-lite">
                <div className="thumbur">
                    <div className="icon-lock"></div>
                </div>
                <h4>{t('user') + (i18n.language !== 'zh' ? ' ' : '') + t('login')}</h4>
                <div className="form-group">
                    <input value={formData.username} required className="form-control" onInput={e => {
                        const { value } = e.target as HTMLInputElement
                        setFormData({
                            ...formData,
                            username: value
                        })
                    }} />
                    <label className="form-label">{t('userName')}</label>
                </div>
                <div className="form-group">
                    <input type="password" value={formData.password} required className="form-control"
                        onInput={e => {
                            const { value } = e.target as HTMLInputElement
                            setFormData({
                                ...formData,
                                password: value
                            })
                        }}
                        onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                            if (e.key === 'Enter') {
                                onLogin()
                            }
                        }}
                    />
                    <label className="form-label">{t('password')}</label>
                </div>
                {/* <a href="#">{t('forgetPsw')} ?  </a> */}
                <button className="floating-btn" onClick={onLogin}><i className="icon-arrow"></i></button>
            </div>
            <div className="copyright">
                Copyright
                <i data-v-7539ee84="" aria-label="copyright"><svg viewBox="64 64 896 896" data-icon="copyright" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"></path></svg></i>
                2022 {t('copyright')}</div>
        </div>
    )
}

export default Login
